import ComingSoon from "@/components/ComingSoon";
import UnderConstructionSvg from "@/components/UnderConstructionSvg";

export default function ComplianceBenchmarksPage() {
  return <ComingSoon featureName="Under Construction" description="CIS benchmark rules, compliance scores, and security assessments. This feature requires backend Compliance APIs." illustration={<UnderConstructionSvg />} />;
}
